<template>
    <button :class="[`button button__${type}`, className]" @click="onClickButton(value)" :disabled="isLoading || isDisable">
        <img class="button__icon" v-if="!isStrEmpty(icon)" :src="require(`@/public/img/${$store.state.config.skin}/${icon}.svg`)" />
        {{ getTranslatedText(value) }}
        <img class="button__icon" v-if="!isStrEmpty(iconRight)" :src="require(`@/public/img/${$store.state.config.skin}/${iconRight}.svg`)" />
        <Loading v-if="isLoading" :isLoadingPage="false" :isLoadingWhiteColor="isLoadingWhiteColor" />
    </button>
</template>
<script>
import EventBus from '@/utils/EventBus';
import Loading from '@/components/common/loading/loading.vue';
import languageMixins from '@/mixins/language-mixins';

import utilsMixin from '@/mixins/function-utils';

export default {
    mixins: [utilsMixin, languageMixins],
    components: { Loading },
    props: {
        type: {
            type: String,
            default: 'default',
        },
        nameFunction: {
            type: String,
            default: '',
        },
        paramFunction: {
            type: [String, Object, Array],
            default: '',
        },
        className: {
            type: String,
            default: '',
        },
        value: {
            type: String,
            default: '',
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        isDisable: {
            type: Boolean,
            default: false,
        },
        isLoadingWhiteColor: {
            type: Boolean,
            default: true,
        },
        icon: {
            type: String,
            default: '',
        },
        iconRight: {
            type: String,
            default: '',
        },
    },
    methods: {
        onClickButton() {
            if (!this.isStrEmpty(this.nameFunction)) {
                EventBus.emit(this.nameFunction, this.paramFunction);
            } else {
                this.$emit('on-click-button-common');
            }
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/common/button.scss';
</style>
